export const capacityPlanningQueryKeys = {
  summary: ['capacity-planning', 'summary'],
  candidates: ['capacity-planning', 'candidates'],
  top: (limit = 10) => ['capacity-planning', 'top', limit],
};
